export class MongoAtlasRestoreAccountAttributes {
    'secretArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "secretArn",
            "baseName": "secretArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
